

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import store from '../store/index.js';
import {reduce} from 'lodash';
import {isAutohomeApp} from '../../../../common/util';
export default {
    data(){
        return {
          commonRightArr: [ {promotionContent: '试驾HS5送188元京东卡'}, {promotionContent: '终身免费保修'}, {promotionContent: '最高3万元置换补贴'}, {promotionContent: '到店送88元京东卡'}],
          // testId: store.testId
          alertFlag: false,
          activityDesc: ''
        }
    },
    mounted() {
      // this.scrollReport();
    },
    computed: {
        showRightObj() {
          var showObj = {rightArr: []};
          var tmpObj = {info: []};
          var tmpArr = []; 
          if (store.userRightArr.length > 0) {
            showObj.haveUserRight = true;
            for (let i=0; i<store.userRightArr.length; i++) {
              // 补全经销商名称
              for (let j=0; j<store.form.dealers.length; j++) {
                if (store.userRightArr[i].dealer == store.form.dealers[j].id) {
                  store.userRightArr[i].dealerName = store.form.dealers[j].name;
                }
              }
              // 如果没有权益，使用默认权益
              if ( store.userRightArr[i].rightArr.length === 0) {
                for (let j=0; j<this.commonRightArr.length; j++) {
                  store.userRightArr[i].rightArr.push(this.commonRightArr[j]);
                }
              }
              showObj.rightArr.push(store.userRightArr[i]);
              setTimeout(() => {
                this.adjustmentHeight();
              }, 0);
            }
          } else {
            // 如果权益没有，使用默认权益
            showObj.haveUserRight = false;
            for (let i=0; i<this.commonRightArr.length; i++) {
              showObj.rightArr.push(this.commonRightArr[i])
            }
          }
          return showObj;
        },
        isUserRightReturn() {
          return store.isUserRightReturn;
        },
        testId() {
          console.log('store.locationSearch.testId', store.testId);
          return store.testId;
        }
    },  
    watch: {
      isUserRightReturn: function (val) {
        var _this = this;
        if (val) {
          _this.$nextTick(function(){
              _this.scrollReport();
          });

        }
      }
    },
    methods: {
      // 寻找block最高的高度并给全部block赋值
      adjustmentHeight: function () {
        var blockEl = document.querySelectorAll('.js-user-right-block');
        // 重置高度
        if (!blockEl) {
          return;
        }
        for(var i=0; i < blockEl.length; i++) {
          blockEl[i].style.height = 'auto';
        }
        var height = 0;
        for(var i=0; i < blockEl.length; i++) {
          if (blockEl[i].offsetHeight > height) {
            height = blockEl[i].offsetHeight;
          }
        }
        for(var i=0; i < blockEl.length; i++) {
          blockEl[i].style.height = height + 'px';
        }
      },
      scrollReport () {
        var _this = this;
        document.querySelector('.js-user-right-content').addEventListener('scroll', function () {
          _this.$clickMonitor.send({
            buttonId: `user-right-activity-report`,
            ...store.getClickMonitorParams()
          });          
        })
      },
      activityClick(res) { // 活动内容弹框事件
        this.alertFlag = true;
        console.log(res)
        if(res.activityDesc){
          this.activityDesc = res.activityDesc;
        }
        // document.querySelector('body').style.position="fixed";
        // document.querySelector('body').style.overflow="hidden";
      },
      activityHide(){
        this.alertFlag = false;
        // document.querySelector('body').style.position="inherit";
        // document.querySelector('body').style.overflow="auto";
      }
    },
}
</script>
<template>
  <div class="wrap" v-show="isUserRightReturn">
      <div class="title">附近优惠</div>
      <div class="content js-user-right-content">
        <div v-if="showRightObj.haveUserRight">
          <div class="block clearfix js-user-right-block" v-bind:key="item.dealerId" v-for="item  in showRightObj.rightArr">
            <div class="activityContent" v-if="item && item.activityTheme" @click="activityClick(item)">活动内容 ></div>
            <div class="block-title" :class="item && item.activityTheme ? 'liutitle' : '' ">{{item.dealerName}}</div>
            <div class="user-right" v-if="item && item.activityTheme">
              <div class="block-activity-theme">
                <img src="../../assets/bell.png" alt="" class="block-activity-theme-img">
                <span class="block-activity-theme-text">{{item.activityTheme}}</span>
              </div>
            </div>
            <div class="block-item" v-bind:key="item2.promotionContent" v-for="item2 in item.rightArr">{{item2.promotionContent}}</div>
          </div>
        </div>
        <div class="one-block clearfix" v-if="!showRightObj.haveUserRight">
          <div class="block-item" v-bind:key="item2.promotionContent" v-for="item2 in showRightObj.rightArr">{{item2.promotionContent}}</div>
        </div>
      </div>

    <div class="liu_alertWindow" v-if="alertFlag">
        <div class="wrapContent" >
            <div class="title">活动内容</div>
            <div class="liu_alertWindowContent" >
                {{activityDesc}}
            </div>
            <div class="liu_alertWindowCloseSure" @click="activityHide">
                继续咨询
            </div>
        </div>
    </div>
  </div>
</template>
<style lang="stylus" scoped>
    .wrap {
      .title {
        color #666666;
        font-size .85rem;
      }
      .content {
        overflow-x: auto;
        white-space:nowrap;
        -webkit-overflow-scrolling:touch;
        padding: 0.5rem 0 .5rem;
        .user-right {
          margin-top -.3rem;
        }
        .block {
          width: 14.5rem;
          font-size: 16px;
          margin-right: .43rem;
          display: inline-table;
          border-radius:0.27rem;
          border:0.03rem solid rgba(227,226,226,1);
          padding: .75rem .64rem .21rem;
          box-sizing border-box;
          position relative;
          .activityContent {
            position:absolute;
            right:0;
            top:1.3rem;
            font-size:0.65rem;
            background: #edf5fb;
            padding: 0.1rem 0.2rem 0.15rem 0.5rem;
            border-radius: 2rem 0 0 2rem;
            color #666;
          }
          .block-title {
            font-size .75rem;
            font-weight:500;
            color #666;
            margin-bottom .53rem;
            white-space:normal;
            word-break:break-all;
          }
          .liutitle {
            width:75%;
          }
          .block-activity-theme {
            position relative;
            background:linear-gradient(180deg,rgba(238,238,238,0) 0%,rgba(216,216,216,0.34) 100%);
            border-radius:0.7rem;
            max-width: 11.87rem;
            padding 0 .37rem;
            margin-bottom: .43rem;
            display: inline-block;
            padding-right: .8rem;
            .block-activity-theme-img {
              height: .64rem;
              position: relative;
              top: .05rem;
              left: .5rem;
            }
            .block-activity-theme-text {
              padding-left: 1.5rem;
              font-size:0.48rem;
              line-height 1.2;
              left 1.2rem;
              color: #666666;
              vertical-align: middle;
              word-wrap: break-word;
              word-break: break-all;
              white-space: normal;
            }
          }
          .block-item {
            font-size:0.64rem;
            color #FF6600;
            padding: .21rem;
            background: rgba(255,102,0,0.1);
            border-radius:0.11rem;
            float left;
            margin 0 .43rem .43rem 0;
            max-width 12rem;
            white-space:normal;
          }
        }
        .one-block {
          width: 100%;
          box-sizing border-box;
          font-size: 16px;
          margin-right: .43rem;
          border-radius:0.27rem;
          border:0.03rem solid rgba(227,226,226,1);
          padding: .75rem .64rem .21rem;
          .block-item {
            font-size:0.64rem;
            color #FF6600;
            padding: .21rem;
            background: rgba(255,102,0,0.1);
            border-radius:0.11rem;
            float left;
            margin 0 .43rem .43rem 0;
            max-width 12rem;
            white-space:normal;
          }
        }
      }
      .clearfix::after {
        content '';
        clear both;
        display block;
      }
    }

    .liu_alertWindow {
        width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); position: fixed; left: 0px; top: 0px; z-index: 9999; display: block;
    }
    .liu_alertWindow .title {
        font-size:0.85rem;
        text-align: center;
        font-weight:bold;
        padding-bottom:0.8rem;
        color:rgba(17,30,54,1);
    }
    .liu_alertWindow .wrapContent {
        width: 13.86rem;height: 19.52rem;background: #FFF;margin: auto;position: relative;top: 50%;transform: translateY(-50%);border-radius: .64rem;padding: 1.07rem;
        
        
    }
    .liu_alertWindow .liu_alertWindowContent {
        width:100%;height: 14.4rem;overflow-y: scroll;
        font-size:0.64rem;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(17,30,54,1);
        line-height:0.96rem;
        margin-bottom: 1rem;
    }
    .liu_alertWindow .liu_alertWindowCloseSure {
        width: 100%;height:2.24rem;
        margin: auto;
        background:linear-gradient(128deg,rgba(255,152,0,1) 0%,rgba(230,25,0,1) 100%);
        box-shadow:0rem 0rem 0.48rem 0rem rgba(244,213,172,0.81);
        border:none;position: relative;top:0.1rem;font-size:.75rem;line-height: 2.24rem;color:#FFFFFF;
        border-radius:0.27rem;
        cursor: pointer;text-align: center;
    }
</style>